import { IForm } from 'core-components/classes/models/IForm'

interface IGetContactBasicInfo {
  contact: IForm
}

export function getContactBasicInfo({ contact }: IGetContactBasicInfo) {
  return [
    {
      label: 'Partner ID',
      value: contact.PartnerID || '-',
    },
    {
      label: 'Communication Name',
      value: contact.CommunicationName || '-',
    },
    {
      label: 'City',
      value: contact.City || '-',
    },
    {
      label: 'Country Of Business',
      value: contact.CountryOfBusiness || '-',
    },
    {
      label: 'Preferred Language',
      value: contact.PreferredLanguage || '-',
    },
    {
      label: 'User Status',
      value: contact.UserStatus || '-',
    },
    {
      label: 'Login ID',
      value: contact.LoginID || '-',
    },
    {
      label: 'HP ID',
      value: contact.HPPassportProfileID || '-',
    },
    {
      label: 'HPD Contact GUID',
      value: contact.HPD_Contact_GUID || '-',
    },
    {
      label: 'Last Login',
      value: contact.UserLastLoginDate || '-',
    },
  ]
}
